import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/InstantPurchaseReport/InstantPurchaseReportAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class InstantPurchaseReportActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/InstantPurchaseReport/InstantPurchaseReport")
	}

	render() {
		return (
			<Activity 
				name="InstantPurchaseReport"
				RenderedComponent={this.RenderedComponent}
				context="InstantPurchaseReport"
				action="InstantPurchaseReport"
				formActions={FormAction}/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(InstantPurchaseReportActivity)
